"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardReportService = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
//EXTERNAL LIBRARY BITS
const token_service_1 = require("./token.service");
//INTERNAL LIBRARY BITS
const notification_service_1 = require("./notification.service");
const loading_service_1 = require("./loading.service");
const bid_data_filter_service_1 = require("./bid-data-filter.service");
const bid_data_service_1 = require("./bid-data.service");
const user_service_1 = require("./user.service");
let DashboardReportService = class DashboardReportService {
    constructor(_http, _talk, _loading, _bidDataFilter, _bidData, _router, _user) {
        this._http = _http;
        this._talk = _talk;
        this._loading = _loading;
        this._bidDataFilter = _bidDataFilter;
        this._bidData = _bidData;
        this._router = _router;
        this._user = _user;
        //initializations
        this.reportURL = '/report';
        this.dataSourceURL = '/datasource';
    }
    create(report, user) {
        let dsString;
        let dsMatch = report.queryParams.match(/dataSource=\w+($|&)/);
        if (dsMatch) {
            dsString = dsMatch[0].replace('dataSource=', '').replace('&', '');
        }
        else {
            return this._talk.broadcast(`Oops. There was an issue saving your report! <i class="fa fa-frown-o" aria-hidden="true"></i><br><br>`);
        }
        return this._http.get(this.dataSourceURL)
            .toPromise()
            .then(resp => {
            const dataSourceId = (JSON.parse(resp._body).find(ds => { return ds.slug === dsString; }) || {}).id;
            if (dataSourceId) {
                return this._http.post(this.reportURL, { "displayName": report.displayName, "queryParams": report.queryParams, "user": user.id, "lastViewed": moment().unix(), 'dataSource': dataSourceId })
                    .toPromise()
                    .then(response => {
                    this._talk.broadcast(`Report saved! <i class="fa fa-smile-o" aria-hidden="true"></i>`);
                    return response;
                });
            }
            else {
                return this._talk.broadcast(`Oops. There was an issue saving your report! <i class="fa fa-frown-o" aria-hidden="true"></i><br><br>`);
            }
        })
            .catch(err => this._talk.broadcast(`Oops. There was an issue saving your report! <i class="fa fa-frown-o" aria-hidden="true"></i><br><br>` + err));
    }
    delete(report) {
        return this._http.delete(this.reportURL + '/' + report.id)
            .toPromise()
            .then(response => {
            return response;
        })
            .catch(err => this._talk.broadcast(`Oops. There was an issue deleting your report! <i class="fa fa-frown-o" aria-hidden="true"></i><br><br>` + err));
    }
    logView(report) {
        return this._http.put(this.reportURL + '/' + report.id, { "lastViewed": moment().unix() })
            .toPromise()
            .then(response => {
            return response;
        })
            .catch(err => console.error('Report View Error: ' + err));
    }
    openReport(report) {
        this.logView(report);
        this._bidDataFilter.resetAllFilters();
        this._loading.start("Fetching Data...");
        return this._router.navigate(['/refresh']).then(err => {
            return Promise.resolve(this._http.qParams = this._bidDataFilter.parseQuery(report.queryParams)).then(res => {
                return this._bidDataFilter.pull().then(res => {
                    return this._bidDataFilter.setQParams(report.queryParams).then(() => {
                        return Promise.resolve(this._bidData.pull()).then(err => {
                            const asyncForReportBidData = () => __awaiter(this, void 0, void 0, function* () {
                                yield this._router.navigate(['/dashboard/main'], { queryParams: this._bidDataFilter.getParsedQParams() });
                                this._loading.stop();
                            });
                            asyncForReportBidData();
                            return true;
                        });
                    });
                });
            });
        });
    }
    saveUserReport(report) {
        return this.create(report, this._user.get()).then(res => {
            return this._user.pull();
        }).catch();
    }
    deleteUserReport(report) {
        return this.delete(report).then(res => {
            this._talk.broadcast(`Report deleted! <i class="fa fa-smile-o" aria-hidden="true"></i>`);
            return this._user.pull();
        }).catch();
    }
};
exports.DashboardReportService = DashboardReportService;
exports.DashboardReportService = DashboardReportService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [token_service_1.TokenService,
        notification_service_1.NotificationService,
        loading_service_1.LoadingService,
        bid_data_filter_service_1.BidDataFilterService,
        bid_data_service_1.BidDataService,
        router_1.Router,
        user_service_1.UserService])
], DashboardReportService);
//# sourceMappingURL=dashboard-report.service.js.map